import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import FiltersSelects from "../../../shared/filters/filtersSelects/FiltersSelects";
import CleanSearch from "../../../shared/filters/cleanSearch/CleanSearch";
import classes from './MobileFilters.module.css'
import BottomPopup from "../../../ui/bottomPopup/BottomPopup";
import iconsList from "../../../ui/icons/iconsList";
import Icon from "../../../ui/icons/Icon";

const MobileFilters = ({ filters, setFilters }) => {

    const { texts } = useSelector(state => state.translate);
    const [showFilters, setShowFilters] = useState()
    const getFilterCount = useMemo(() => { return !filters ? null : Object.values(filters)?.reduce((sum, val) => sum + val?.length, 0) }, [filters])

    return (
        <div>
            <button className={classes.Filter} onClick={() => setShowFilters(true)}>
                <Icon name={iconsList.filter} size="24px" />
                {texts.filter}
                {getFilterCount && <div className={classes.MobileCircle} />}
            </button>

            {showFilters &&
                <BottomPopup onClose={() => setShowFilters(false)}>
                    <div className={classes.MobileFilters}>
                        <FiltersSelects setFilters={setFilters} filters={filters} />
                        <button className={classes.StartFilter} onClick={() => setShowFilters(false)}>{texts.startFilter}</button>
                        <CleanSearch onSearchClick={() => setShowFilters(false)} setFilters={setFilters} />
                    </div>
                </BottomPopup>
            }
        </div>
    )
}

export default MobileFilters;